module.exports = "li {\n  list-style-type: none; }\n\nul {\n  margin-top: 0px;\n  padding-left: 0px; }\n"